import React, { useState, useEffect } from 'react';
import { Grid, Button, Typography } from '@material-ui/core';
import KenDialog from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenCheckbox from '../../../../global_components/KenCheckbox/index';
import KenInputField from '../../../../global_components/KenInputField';
import KenGrid from '../../../../global_components/KenGrid';
import KenCard from '../../../../global_components/KenCard';
import KenSnackbar from '../../../../Components/KenSnackbar/index';

import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/EditOutlined';
import {
  getAddPromotionCriteriaDataFilter,
  getAcademicFilter,
  getAddPromotionCriteriaData,
  getPromotionCriteriaData,
  getSinglPromotionCriteriaData,
} from '../../../../Utils/apiServices';
import KenLoader from '../../../../Components/KenLoader/index';

import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  resposiveTable: {
    // overflowX: 'auto',
  },
}));

const defaultValues = {
  AcademicProgram: '',
  TermNumber: [],
};
const editValues = {
  AcademicProgram: '',
  TermNumber: '',
};
const defaultErrorValues = {
  AcademicProgram: '',
  TermNumber: '',
};

const Promotion = ({
  criteriaNameLabel,
  FeeStatus,
  Grade,
  title,
  opertionFilter,
}) => {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);

  const [loading, setLoading] = useState(false);
  const [masterDialog, setMasterDialog] = useState(false);
  const [isChecked, setIsChecked] = useState([]);
  const [createFormulavalues, setcreateFormulavalues] = useState('');
  const [formValues, setFormValues] = useState(
    editMode === true ? editValues : defaultValues
  );
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const [getdata, setData] = useState([]);
  const [error, setError] = useState(defaultErrorValues);
  const [CreateFormula, setCreateFormula] = useState(false);
  const [CreateFormulaError, setCreateFormulaError] = useState('');
  const [countChecked, setCountChecked] = useState('');
  const [preview, setPreview] = useState('');
  const [criteriaName, setcriteriaName] = useState('');
  const [CourseOptions, setCourseOptions] = useState('');
  const [masterCriteriaId, setmasterCriteriaId] = useState('');
  const [masterCriteriaName, setmasterCriteriaName] = useState('');
  const [criteriaId, setcriteriaId] = useState('');
  const [termOptions, setTermOptions] = useState([]);
  const [nameofFilter, setnameofFilter] = useState([]);
  const [maxDurationAllowedForEnrollment, setmaxDurationAllowedForEnrollment] =
    useState('');
  const [minDurationAllowedForEnrollment, setminDurationAllowedForEnrollment] =
    useState('');

  const [masterHead, setmasterHead] = useState(
    criteriaNameLabel === 'Term Promotion'
      ? [
          {
            Header: 'Academic Program',
            accessor: 'AcademicProgram',
            sticky: 'left',
            disableGlobalFilter: false,
          },
          {
            Header: 'Term Number',
            accessor: 'TermNumber',
            sticky: 'left',
            disableGlobalFilter: false,
          },
        ]
      : criteriaNameLabel === 'Graduation'
      ? [
          {
            Header: 'Academic Program',
            accessor: 'AcademicProgram',
            disableGlobalFilter: false,
          },
        ]
      : [
          {
            Header: 'Academic Program',
            accessor: 'AcademicProgram',
            disableGlobalFilter: false,
          },
          {
            Header: 'Term Number',
            accessor: 'TermNumber',
            disableGlobalFilter: false,
          },
        ]
  );

  useEffect(() => {
    setLoading(true);
    getAddPromotionCriteriaDataFilter(criteriaNameLabel)
      .then((res) => {
        setcriteriaName(res.data[0].CriteriaFilter);
        const header = res.data[0].CriteriaFilter.map((Criteria) => {
          return {
            Header: Criteria.criteriaName,
            accessor: Criteria.criteriaName,
            disableGlobalFilter: false,
            Cell: (props) => {
              return <span> {props.value ?? '-'}</span>;
            },
          };
        });
        setnameofFilter(
          res.data[0].CriteriaFilter.map((name) => {
            return name.criteriaName;
          })
        );

        const edit = {
          Header: 'Action',
          accessor: 'EditMode',
          disableGlobalFilter: false,
        };

        setmasterHead([...masterHead, ...header, edit]);
        const formOBJ = {};
        res.data[0].CriteriaFilter.forEach((criteria) => {
          formOBJ[criteria.criteriaName] = '';
        });
        setmasterCriteriaId(res.data[0].criteriaId);
        setmasterCriteriaName(res.data[0].criteriaType);
        setFormValues({ ...formValues, ...formOBJ });
        setError({ ...error, ...formOBJ });
        setLoading(false);
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
        setLoading(false);
      });
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: keyVal.id,
            id: keyVal.id,
            noOfTerms: keyVal.noOfTerms,
            terms: JSON.parse(keyVal.terms),
          });
        });
        setCourseOptions(courseOptions);
        setLoading(false);
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
        setLoading(false);
      });
  }, [criteriaNameLabel]);

  const onToggleEditMode = (criteriaId, AcademicProgramId, TermNumber) => {
    setMasterDialog(true);
    setcriteriaId(criteriaId);
    setEditMode(true);
    setcreateFormulavalues('');

    getSinglPromotionCriteriaData(
      criteriaNameLabel,
      criteriaId,
      AcademicProgramId,
      TermNumber
    )
      .then((res) => {
        setcreateFormulavalues(res.data[0].formula);

        const FilterCriteria = {};
        const filterName = {
          AcademicProgram: res.data[0].academicProgramId,
          TermNumber: res.data[0].termNumber,
        };
        res.data[0].CriteriaFilter.forEach((criteria) => {
          if (
            criteria.criteriaName === 'Max No Of Subjects With Cut-Off Grade 2'
          ) {
            FilterCriteria[criteria.criteriaName] = false;
          } else if (
            criteria.criteriaName === 'Max No Of Subjects With Cut-Off Grade 1'
          ) {
            FilterCriteria[criteria.criteriaName] = false;
          } else {
            FilterCriteria[criteria.criteriaName] = true;
          }
        });
        res.data[0].CriteriaFilter.forEach((criteria) => {
          console.log('criteriacriteriacriteria', criteria);
          if (criteria.criteriaName === 'Cut-OFF Grade 2') {
            filterName['Cut-OFF Grade 2'] =
              criteria.criteriaValue.split(';')[0];
            filterName['Max No Of Subjects With Cut-Off Grade 2'] =
              criteria.criteriaValue.split(';')[1];
            filterName['Max No Of Subjects With Cut-Off Grade 2 opertor'] =
              criteria.filterOperator;
            return;
          }
          if (criteria.criteriaName === 'Cut-OFF Grade 1') {
            filterName['Cut-OFF Grade 1'] =
              criteria.criteriaValue.split(';')[0];
            filterName['Max No Of Subjects With Cut-Off Grade 1'] =
              criteria.criteriaValue.split(';')[1];
            filterName['Max No Of Subjects With Cut-Off Grade 1 opertor'] =
              criteria.filterOperator;

            return;
          }
          filterName[criteria.criteriaName] = criteria.criteriaValue;
          filterName[criteria.criteriaName + ' opertor'] =
            criteria.filterOperator;
        });

        let count = 0;
        const checkedValues = {};
        Object.entries(FilterCriteria).forEach(([item, keyVal]) => {
          if (keyVal === true) {
            const CheckboxName = item;
            count++;
            checkedValues[CheckboxName] = count;
          }
        });
        setCountChecked(checkedValues);

        setIsChecked({ ...FilterCriteria });
        setFormValues({ ...formValues, ...filterName });
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    getPromotionCriteriaData(criteriaNameLabel, criteriaId)
      .then((res) => {
        const getDataAll = [];
        setmaxDurationAllowedForEnrollment(
          res.data[0].maxDurationAllowedForEnrollment
        );
        setminDurationAllowedForEnrollment(
          res.data[0].minDurationAllowedForEnrollment
        );
        res.data.forEach((getData) => {
          const innerLoop = {};
          innerLoop['AcademicProgram'] = getData.academicProgramName;
          innerLoop['criteriaId'] = getData.criteriaId;
          innerLoop['TermNumber'] =
            getData.termNumber === null ? '-' : getData.termNumber;
          innerLoop['AcademicProgramId'] = getData.academicProgramId;
          innerLoop['criteriaId'] = getData.criteriaId;

          getData.CriteriaFilter.forEach((CriteriaFilter) => {
            innerLoop[CriteriaFilter.criteriaName] =
              CriteriaFilter.criteriaValue || '-';
          });

          getDataAll.push(innerLoop);
        });
        const allDataGet = getDataAll.map((loop) => {
          const OBJ = {};
          Object.keys(loop).forEach((key) => {
            console.log('keykeykeykey', key);
            if (key === 'Cut-OFF Grade 1') {
              OBJ['Cut-OFF Grade 1'] = loop['Cut-OFF Grade 1'].split(';')[0];
              OBJ['Max No Of Subjects With Cut-Off Grade 1'] =
                loop['Cut-OFF Grade 1'].split(';')[1];
              return;
            }
            if (key === 'Cut-OFF Grade 2') {
              OBJ['Cut-OFF Grade 2'] = loop['Cut-OFF Grade 2'].split(';')[0];
              OBJ['Max No Of Subjects With Cut-Off Grade 2'] =
                loop['Cut-OFF Grade 2'].split(';')[1];
              return;
            }
            if (key === 'Maximum Duration Allowed From Program Enrollment') {
              OBJ['Maximum Duration Allowed From Program Enrollment'] =
                res.data[0].maxDurationAllowedForEnrollment;

              return;
            }
            if (key === 'Minimum Duration Allowed From Program Enrollment') {
              OBJ['Minimum Duration Allowed From Program Enrollment'] =
                res.data[0].minDurationAllowedForEnrollment;

              return;
            }
            OBJ[key] = loop[key];
          });
          return {
            ...OBJ,
            EditMode: (
              <IconButton
                aria-label="edit"
                onClick={() =>
                  onToggleEditMode(
                    loop.criteriaId,
                    loop.AcademicProgramId,
                    loop.TermNumber
                  )
                }
              >
                <EditIcon />
              </IconButton>
            ),
          };
        });
        setData(allDataGet);
        setLoading(false);
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
        setLoading(false);
      });
  }, [criteriaId, criteriaNameLabel, masterDialog]);

  useEffect(() => {
    const termOption = [];
    CourseOptions.length > 0 &&
      CourseOptions.map((course) => {
        const terms = parseInt(course.noOfTerms);
        if (formValues.AcademicProgram === course.value) {
          if (terms === NaN) {
            setTermOptions([]);
          } else {
            for (let i = 1; i <= terms; i++) {
              termOption.push({ label: i, value: i.toString() });
            }
            setTermOptions(termOption);
          }
        } else {
          setTermOptions(termOption);
          return;
        }
      });
  }, [CourseOptions, formValues.AcademicProgram]);

  const masterImportDialog = () => {
    setFormValues(defaultValues);
    setError(defaultValues);
    setIsChecked(false);
    setCountChecked('');
    setPreview('');
    setMasterDialog(true);
    setEditMode(false);
    setCreateFormulaError('');
    setcreateFormulavalues('');
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleChecked = (e) => {
    const { name, checked } = e.target;

    setIsChecked({
      ...isChecked,
      [name]: checked,
    });
    setPreview('');
    setCreateFormulaError('Formula is not correct');
    checkboxes();
  };

  const handleExamEligibility = () => {
    Object.entries(countChecked).forEach(([key, checked]) => {
      if (formValues[key] === undefined) {
        setError({ ...error, [key]: 'Please select value' });
        return;
      }
      setError({ ...error, [key]: '' });
      return;
    });
    const result = [];
    const FilterCriteria = [];
    Object.entries(countChecked).map(([key, checked]) => {
      const filter = criteriaName
        .filter((criteria) => {
          return criteria.criteriaName === key;
        })
        .map((filterType) => {
          console.log('filterTypefilterTypefilterTypefilterType', filterType);
          return {
            filter: filterType.filterType,
            filterObjectType: filterType.filterObjectType,
            filterField: filterType.filterField,
          };
        });
      filter.map((filterValue) => {
        FilterCriteria.push({
          filterType: filterValue.filter,
          filterOperator:
            key === 'Cut-OFF Grade 2'
              ? formValues['Max No Of Subjects With Cut-Off Grade 2 opertor']
              : key === 'Cut-OFF Grade 1'
              ? formValues['Max No Of Subjects With Cut-Off Grade 1 opertor']
              : formValues[key + ' opertor'],
          filterObjectType: filterValue.filterObjectType,
          filterField: filterValue.filterField,
          criteriaName: key,
          criteriaValue:
            key === 'Cut-OFF Grade 2'
              ? formValues[key] +
                ';' +
                formValues['Max No Of Subjects With Cut-Off Grade 2']
              : key === 'Cut-OFF Grade 1'
              ? formValues[key] +
                ';' +
                formValues['Max No Of Subjects With Cut-Off Grade 1']
              : formValues[key],

          filterOrder: checked,
        });
      });
    });
    result.push({
      Operation: 'create',
      Criteria: {
        criteriaType: masterCriteriaName,
        academicProgramId: formValues.AcademicProgram,

        termNumber:
          editMode === true
            ? formValues.TermNumber
            : formValues.TermNumber.join(','),
        masterCriteriaId: masterCriteriaId,
        formula: createFormulavalues,
        criteriaId: criteriaId,
        FilterCriteria: FilterCriteria,
      },
    });
    setData([...getdata, ...result]);
    if (criteriaNameLabel !== 'Graduation') {
      if (formValues.AcademicProgram && formValues.TermNumber.length > 0) {
        let errorValue;
        Object.entries(countChecked).forEach(([key, checked]) => {
          if (formValues[key]) {
            errorValue = false;
          } else {
            errorValue = true;
          }
        });
        console.log('errorValueerrorValue', errorValue);
        if (errorValue === false) {
          setLoading(true);
          getAddPromotionCriteriaData(criteriaNameLabel, result[0])
            .then((res) => {
              console.log('resresresres', res);
              if (res.success === 'true') {
                handleSnackbarOpen('success', 'Added Criteria');

                setMasterDialog(false);
                setLoading(false);
              }
            })
            .catch((err) => {
              handleSnackbarOpen('error', err.message);
              setLoading(false);
              setMasterDialog(false);
            });
        }
      }
    } else {
      if (formValues.AcademicProgram) {
        let errorValue;
        Object.entries(countChecked).forEach(([key, checked]) => {
          if (formValues[key]) {
            errorValue = false;
          } else {
            errorValue = true;
          }
        });
        if (errorValue === false) {
          setLoading(true);
          getAddPromotionCriteriaData(criteriaNameLabel, result[0])
            .then((res) => {
              if (res.success === 'true') {
                handleSnackbarOpen('success', 'Added Criteria');
                setMasterDialog(false);
                setLoading(false);
              } else {
                handleSnackbarOpen('error', 'Not added criteria');
                setLoading(false);
                setMasterDialog(false);
              }
            })
            .catch((err) => {
              handleSnackbarOpen('error', err.message);
              setLoading(false);
            });
        }
      }
    }
  };

  function checkboxes() {
    var inputElems = document.getElementsByTagName('input'),
      count = 0;
    const checkedValues = {};
    for (var i = 0; i < inputElems.length; i++) {
      if (inputElems[i].type === 'checkbox' && inputElems[i].checked === true) {
        const CheckboxName = inputElems[i].name;
        count++;
        checkedValues[CheckboxName] = count;
      }
    }
    setCountChecked(checkedValues);
  }
  const extractNumbers = (string) => {
    const regex = /[0-9/ /]/g;
    const nums = string.match(regex);
    const newText = nums.join(',');
    return newText;
  };
  const createRegexp = /^((?!AND|OR).)*$/;
  var regExp = /\(([^)]+)\)/;
  useEffect(() => {
    let stringvalue = '';
    if (countChecked) {
      Object.values(countChecked).forEach((checkvalue, index) => {
        if (index === Object.values(countChecked).length - 1) {
          stringvalue = stringvalue + checkvalue.toString();
        } else {
          stringvalue = stringvalue + checkvalue.toString() + ' AND ';
        }
      });
      setcreateFormulavalues(stringvalue);
    }
  }, [countChecked]);
  const boldeMe = (input) => {
    let output = input.replace(/AND|OR/g, function (match) {
      return `<b>${match}</b>`;
    });
    return output;
  };

  // var count = 0;
  useEffect(() => {
    if (createFormulavalues !== '')
      if (
        regExp.test(createFormulavalues) ||
        !createRegexp.test(createFormulavalues)
      ) {
        const newValue = extractNumbers(createFormulavalues);
        const valueSplit = newValue.split(',');
        valueSplit?.forEach((check) => {
          Object.values(countChecked).map((checkarray) => {
            if (checkarray === parseInt(check)) {
              var replaceArray = Object.values(countChecked);
              var replaceArrayValue = Object.keys(countChecked);
              var finalAns = createFormulavalues;
              for (var i = replaceArray.length - 1; i >= 0; i--) {
                if (formValues[replaceArrayValue[i]] !== undefined)
                  finalAns = finalAns.replace(
                    replaceArray[i],
                    replaceArrayValue[i] +
                      ' ' +
                      formValues[replaceArrayValue[i] + ' opertor'] +
                      ' ' +
                      formValues[replaceArrayValue[i]]
                  );
              }

              setPreview(finalAns);

              setCreateFormulaError('');
            } else {
              setPreview('');
              setCreateFormulaError('Formula is not correct');
            }
          });
        });
      } else {
        setPreview('');
        setCreateFormulaError('Formula is not correct');
      }
  }, [countChecked, createRegexp, regExp]);

  const changeFormulaHandler = (e) => {
    setcreateFormulavalues(e.target.value);
  };

  return (
    <Grid container>
      {loading && <KenLoader />}
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />

      <KenDialog
        title={
          editMode === false ? (
            <Typography variant="h6">
              Add {criteriaNameLabel} criteria
            </Typography>
          ) : (
            <Typography variant="h6">
              Edit {criteriaNameLabel} criteria
            </Typography>
          )
        }
        open={masterDialog}
        handleClose={() => setMasterDialog(false)}
        negativeButtonClick={() => {
          setMasterDialog(false);
        }}
        positiveButtonClick={() => {
          CreateFormula === true
            ? setMasterDialog(false)
            : handleExamEligibility();
        }}
        maxWidth={'md'}
        positiveButtonText={'Save'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={2} className="custom-select-box">
          <Grid item xs={6}>
            <KenSelectWrap
              name="AcademicProgram"
              label="Academic Program"
              options={CourseOptions}
              value={formValues.AcademicProgram}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleInputChange(e)}
              required
            />
            <p className="error-message">
              {formValues.AcademicProgram === '' ? 'Please select value' : ''}
            </p>
          </Grid>
          {criteriaNameLabel !== 'Graduation' ? (
            editMode === false ? (
              <Grid item xs={6}>
                <KenSelectWrap
                  name="TermNumber"
                  multiple={true}
                  selectMultiple={true}
                  setFormValues={setFormValues}
                  formValues={formValues}
                  label="Term Number"
                  options={termOptions}
                  value={formValues.TermNumber}
                  dropdownColor="#FFFFFF"
                  required
                />
                <p className="error-message">
                  {formValues.TermNumber.length < 0
                    ? 'Please select value'
                    : ''}
                </p>
              </Grid>
            ) : (
              <Grid item xs={6}>
                <KenSelectWrap
                  name="TermNumber"
                  label="Term Number"
                  options={termOptions}
                  value={formValues.TermNumber}
                  dropdownColor="#FFFFFF"
                  onChange={(e) => handleInputChange(e)}
                  required
                />
                <p className="error-message">
                  {formValues.TermNumber === '' ? 'Please select value' : ''}
                </p>
              </Grid>
            )
          ) : (
            <Grid item xs={6} />
          )}

          {criteriaName.length > 0 &&
            criteriaName.map((criteria) => {
              console.log('criteriacriteriacriteria', criteria);
              return (
                <>
                  <Grid
                    item
                    xs={6}
                    className={
                      (criteria.criteriaName ===
                        'Max No Of Subjects With Cut-Off Grade 1' &&
                        'mainDivDisplaynone') ||
                      (criteria.criteriaName ===
                        'Max No Of Subjects With Cut-Off Grade 2' &&
                        'mainDivDisplaynone')
                    }
                  >
                    <div className="examCheckdiv">
                      {criteria.criteriaName ===
                        'Max No Of Subjects With Cut-Off Grade 1' ||
                      criteria.criteriaName ===
                        'Max No Of Subjects With Cut-Off Grade 2' ? (
                        ''
                      ) : (
                        <KenCheckbox
                          name={criteria.criteriaName}
                          value={
                            editMode === true
                              ? isChecked[criteria.criteriaName] !== undefined
                                ? isChecked[criteria.criteriaName]
                                : false
                              : isChecked[criteria.criteriaName]
                          }
                          onChange={(e) => handleChecked(e)}
                          color="primary"
                          id="select"
                          className="ExamCheckbox"
                          checkclassName="ExamCheckpart"
                          label={criteria.criteriaName}
                          disabled={false}
                        />
                      )}

                      {countChecked[criteria.criteriaName] && (
                        <span className="criteriaNumber">
                          {countChecked[criteria.criteriaName]}
                        </span>
                      )}
                    </div>
                    {isChecked[criteria.criteriaName] === true && (
                      <>
                        {criteria.typePicklist === 'FeeStatus' ? (
                          <KenSelectWrap
                            name={criteria.criteriaName}
                            options={FeeStatus}
                            value={formValues[criteria.criteriaName]}
                            dropdownColor="#FFFFFF"
                            onChange={(e) => handleInputChange(e)}
                            required
                          />
                        ) : criteria.criteriaName === 'Cut-OFF Grade 2' ? (
                          <>
                            <KenSelectWrap
                              name={criteria.criteriaName}
                              options={Grade}
                              value={formValues[criteria.criteriaName]}
                              dropdownColor="#FFFFFF"
                              onChange={(e) => handleInputChange(e)}
                              required
                            />

                            <div className="criteriaMainDiv">
                              <div className="criteriaDropdown">
                                <KenSelectWrap
                                  name={
                                    'Max No Of Subjects With Cut-Off Grade 2 opertor'
                                  }
                                  label={'Grade 2 opertor'}
                                  options={opertionFilter}
                                  value={
                                    formValues[
                                      'Max No Of Subjects With Cut-Off Grade 2 opertor'
                                    ] === undefined
                                      ? ''
                                      : formValues[
                                          'Max No Of Subjects With Cut-Off Grade 2 opertor'
                                        ]
                                  }
                                  dropdownColor="#FFFFFF"
                                  onChange={(e) => handleInputChange(e)}
                                  required
                                />
                              </div>
                              <div className="criteriaInputDiv">
                                <KenInputField
                                  type={criteria.typePicklist}
                                  label={
                                    'Max No Of Subjects With Cut-Off Grade 2'
                                  }
                                  value={
                                    formValues[
                                      'Max No Of Subjects With Cut-Off Grade 2'
                                    ]
                                  }
                                  name={
                                    'Max No Of Subjects With Cut-Off Grade 2'
                                  }
                                  dropdownColor="#FFFFFF"
                                  required
                                  onChange={(e) => handleInputChange(e)}
                                />
                              </div>
                            </div>
                          </>
                        ) : criteria.criteriaName === 'Cut-OFF Grade 1' ? (
                          <>
                            <KenSelectWrap
                              name={criteria.criteriaName}
                              options={Grade}
                              value={formValues[criteria.criteriaName]}
                              dropdownColor="#FFFFFF"
                              onChange={(e) => handleInputChange(e)}
                              required
                            />
                            <div className="criteriaMainDiv">
                              <div className="criteriaDropdown">
                                <KenSelectWrap
                                  name={
                                    'Max No Of Subjects With Cut-Off Grade 1 opertor'
                                  }
                                  options={opertionFilter}
                                  label={'Grade 1 opertor'}
                                  value={
                                    formValues[
                                      'Max No Of Subjects With Cut-Off Grade 1 opertor'
                                    ] === undefined
                                      ? ''
                                      : formValues[
                                          'Max No Of Subjects With Cut-Off Grade 1 opertor'
                                        ]
                                  }
                                  dropdownColor="#FFFFFF"
                                  onChange={(e) => handleInputChange(e)}
                                  required
                                />
                              </div>
                              <div className="criteriaInputDiv">
                                <KenInputField
                                  type={criteria.typePicklist}
                                  label={
                                    'Max No Of Subjects With Cut-Off Grade 1'
                                  }
                                  value={
                                    formValues[
                                      'Max No Of Subjects With Cut-Off Grade 1'
                                    ]
                                  }
                                  name={
                                    'Max No Of Subjects With Cut-Off Grade 1'
                                  }
                                  dropdownColor="#FFFFFF"
                                  required
                                  onChange={(e) => handleInputChange(e)}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="criteriaMainDiv">
                            <div className="criteriaDropdown">
                              <KenSelectWrap
                                name={criteria.criteriaName + ' opertor'}
                                options={opertionFilter}
                                value={
                                  criteria.typePicklist === 'Blank'
                                    ? (formValues[
                                        criteria.criteriaName + ' opertor'
                                      ] = criteria.filterOperator)
                                    : formValues[
                                        criteria.criteriaName + ' opertor'
                                      ] === undefined
                                    ? ''
                                    : formValues[
                                        criteria.criteriaName + ' opertor'
                                      ]
                                }
                                dropdownColor="#FFFFFF"
                                onChange={(e) => handleInputChange(e)}
                                required
                                disabled={criteria.typePicklist === 'Blank'}
                              />
                            </div>
                            <div className="criteriaInputDiv">
                              <KenInputField
                                type={criteria.typePicklist}
                                value={
                                  criteria.typePicklist === 'Blank' &&
                                  criteria.criteriaName ===
                                    'Maximum Duration Allowed From Program Enrollment'
                                    ? (formValues[criteria.criteriaName] =
                                        maxDurationAllowedForEnrollment)
                                    : criteria.typePicklist === 'Blank' &&
                                      criteria.criteriaName ===
                                        'Minimum Duration Allowed From Program Enrollment'
                                    ? (formValues[criteria.criteriaName] =
                                        minDurationAllowedForEnrollment)
                                    : formValues[criteria.criteriaName]
                                }
                                name={criteria.criteriaName}
                                dropdownColor="#FFFFFF"
                                required
                                onChange={(e) => handleInputChange(e)}
                                disabled={criteria.typePicklist === 'Blank'}
                              />
                            </div>
                          </div>
                        )}

                        <p className="error-message">
                          {error[criteria.criteriaName]}
                        </p>
                      </>
                    )}
                  </Grid>
                </>
              );
            })}
        </Grid>
        <Grid container spacing={2} className="custom-select-box">
          <Grid item xs={6}>
            <KenInputField
              label="Create Formula"
              name="createformula"
              value={createFormulavalues}
              dropdownColor="#FFFFFF"
              required
              onChange={(e) => changeFormulaHandler(e)}
            />
            <p className="error-message">{CreateFormulaError}</p>
          </Grid>
          <Grid item xs={6}>
            <label className="custom-label-preview">Preview</label>
            <Grid item xs={6} className="text-bold">
              <label>
                {' '}
                <span
                  dangerouslySetInnerHTML={{
                    __html: boldeMe(preview),
                  }}
                />
              </label>
            </Grid>
          </Grid>
        </Grid>
      </KenDialog>

      <Grid className="examButton">
        <Button
          className="examButton"
          variant="contained"
          color="primary"
          onClick={masterImportDialog}
        >
          Add New
        </Button>
      </Grid>
      <Grid
        style={{
          width: '100%',
        }}
      >
        <div className="promotion-table">
          <KenCard elevation={0}>
            <KenGrid
              columns={masterHead}
              data={getdata}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
            />
          </KenCard>
        </div>
      </Grid>
    </Grid>
  );
};

export default Promotion;
